export default "__VITE_ASSET__Bh6GxtKP__"